import { createSlice } from '@reduxjs/toolkit';

const taskScrollSlice = createSlice({
  name: 'taskScroll',
  initialState: {
    selectedTaskId: null,
    selectedProjectName: "",
    autoExpandAllTaskDetails: false,
  },
  reducers: {
    setSelectedTaskId: (state, action) => {
      state.selectedTaskId = action.payload;
    },
    setSelectedProjectName: (state, action) => {
      state.selectedProjectName = action.payload;
    },
    setAutoExpandAllTaskDetails: (state, action) => {
      state.autoExpandAllTaskDetails = Boolean(action.payload);
    },
  },
});

export const { setSelectedTaskId, setSelectedProjectName, setAutoExpandAllTaskDetails } =
  taskScrollSlice.actions;
export default taskScrollSlice.reducer;
